import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import NewsRelationsOption from './NewsRelationsOption';

const NewsRelations = (props) => {

    return (
        <div data-cy-article-category className="form-group row">
            <label className="col-sm-2 col-form-label">
                <b>{props.labelName}</b>
                <small className="form-text text-muted">
                    Maksimalt 3 relationer
                </small>
            </label>
            <div className="col-sm-10">
                <Select
                    {...props}
                    value={props.input.value}
                    options={props.options}
                    onChange={(value) => {
                        if(value.length <= 3) {
                            props.input.onChange(value);
                        }
                    }}
                    optionComponent={NewsRelationsOption}
                    multi={true}
                    placeholder={props.intl.formatMessage(messages.categoriesSelect)}
                    clearable={false}
                    onBlur={() => props.input.onBlur(props.input.value)}
                />
            </div>
        </div>
    );
};

export default injectIntl(NewsRelations);




// WEBPACK FOOTER //
// ./web/src/components/company/NewsRelations.jsx